import(/* webpackMode: "eager" */ "/build/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/build/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/build/src/components/aspect-ratio.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LinkTrackers"] */ "/build/src/components/reusables/link-trackers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/build/src/components/reusables/strapi-blocks-renderer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/build/src/components/reusables/topic-tag.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AspectRatio"] */ "/build/src/components/ui/aspect-ratio.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Dialog","DialogTrigger","DialogContent","DialogTitle","DialogClose"] */ "/build/src/components/ui/dialog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollArea"] */ "/build/src/components/ui/scroll-area.tsx");
